export default {
  'robot2s': [
    {
      title:'外形',
      params: [
        ['重量', '5.8KG（含充电座共7KG）'],
        ['尺寸', '259X258X506mm(含充电座260X326X520mm)'],
        ['表面工艺', 'UV，电镀'],
      ],
    },
    {
      title:'摄像头',
      icon: 'icon-camera',
      params: [
        ['视角', '超广角支持，低畸变'],
        ['水平视角', '83°'],
        ['像素', '1300万像素'],
        ['帧率', '根据网络自适配帧率'],
      ],
    },
    {
      title:'音箱',
      icon: 'icon-voicebox',
      params: [
        ['输出功率', '2X10W'],
        ['声道', '双声道，立体声'],
        ['音质特色', '双喇叭，独创低频辐射振膜系统，使低频获得更均匀的扩散，低频力度强，音质层次分明'],
      ],
    },
    {
      title:'麦克风',
      icon: 'icon-mic',
      params: [
        ['阵列数', '6'],
        ['识别距离', '室内环境下有效识别距离3～5米，识别率不低于90%，静音空旷环境最大识别距离10米'],
        ['特色功能', '混响消除，回声消除，自动降燥，远场语音'],
      ],
    },
    {
      title:'屏幕尺寸',
      icon: 'icon-screen',
      params: [
        ['尺寸', '5英寸，IPS全贴合'],
        ['分辨率', '1080X720'],
      ],
    },
    {
      title:'核心硬件',
      icon: 'icon-hardware',
      params: [
        ['CPU', '四核Cortex-A17'],
        ['RAM', '2GB，DDR3双通道'],
        ['ROM', '8GB'],
      ],
    },
    {
      title:'运动',
      icon: 'icon-move',
      params: [
        ['头部', ['俯角5°', '仰角25°', '水平旋转左右90°', '俯仰、旋转速度均可达到60°／S', '噪声<45dB(距离1米)']],
        ['身体', ['行走速度0.2m／s', '越障10mm', '越沟10～30mm', '爬坡10～15°', '噪声 <55dB( 距离1米)']],
      ],
    },
    {
      title:'无线通讯',
      icon: 'icon-wifi',
      params: [
        ['Wi-Fi', '802.11n'],
        ['ZigBee', 'ZHA'],
        ['射频', '433MHZ'],
      ],
    },
    {
      title:'电源',
      icon: 'icon-battery',
      params: [
        ['电池', '18650锂电池，10400mAh'],
        ['续航时间', '音乐播放长达6小时，待机长达24小时'],
        ['充电方式', '自动回充，充满电大约需要6小时'],
      ],
    },
  ],
  'robot3': [
    {
      title:'外形',
      params: [
        ['重量', '11KG'],
        ['尺寸', '底盘直径： 338.2mm，高度：收合态435mm，伸展态628.5mm'],
        ['表面工艺', '曜石黑、幻银灰'],
      ],
    },
    {
      title:'摄像头',
      icon: 'icon-camera',
      params: [
        ['视角', '176°超级广角镜头'],
        ['图像传感器', '1/2.8"'],
        ['光圈', 'F1.8大'],
        ['摄像头', ['高清1080P', '星光级全彩']],
      ],
    },
    {
      title:'音箱',
      icon: 'icon-voicebox',
      params: [
        ['输出功率', '2X10W'],
        ['声道', '双声道，立体声'],
        ['频响范围', 'TBD'],
      ],
    },
    {
      title:'麦克风',
      icon: 'icon-mic',
      params: [
        ['阵列数', '6'],
        ['声源定位', '360°'],
        ['特色功能', '回声消除、稳态/动态噪声抑制、语音增强'],
      ],
    },
    {
      title:'屏幕尺寸',
      icon: 'icon-screen',
      params: [
        ['显示屏', '10.1"IPS'],
        ['分辨率', ['1080X720', '支持多点触摸']],
      ],
    },
    {
      title:'核心硬件',
      icon: 'icon-hardware',
      params: [
        ['CPU', '双CPU，六核64位高性能处理器'],
        ['RAM', '2GB'],
        ['ROM', '8GB'],
      ],
    },
    {
      title:'运动',
      icon: 'icon-move',
      params: [
        ['行走', '正常速度0.4m/s、最大速度可达0.8/s'],
        ['俯仰', '范围0~55°，速度45°/s'],
        ['水平旋转', '范围-150°~150°、速度45°/s'],
        ['上下伸缩', '区间7cm、速度3cm/s'],
      ],
    },
    {
      title:'传感器',
      icon: 'icon-sensor',
      params: [
        ['超声传感器', '4'],
        ['红外传感器', '6'],
        ['环境传感器', '1'],
        ['IMU', '1'],
        ['激光雷达', '1'],
      ],
    },
    {
      title:'无线通讯',
      icon: 'icon-wifi',
      params: [
        ['Wi-Fi', '802.11b/g/n(2.4GHz)'],
        ['ZigBee', 'IEEE802.15.4 250kbps(2.4GHz)'],
        ['BT', 'V2.1+EDR/BT V3.0/BT v3.0+HS/BT V4.0'],
      ],
    },
    {
      title:'电源',
      icon: 'icon-battery',
      params: [
        ['电池', '18650锂电池、容量10400mAh、额定电压11.1V'],
        ['充电方式', '自动回充'],
      ],
    },
  ],
  'robot3s': [
    {
      title:'外形',
      params: [
        ['重量', '11KG'],
        ['尺寸', '底盘直径： 338.2mm，高度：收合态435mm，伸展态628.5mm'],
        ['表面工艺', '曜石黑、幻银灰'],
      ],
    },
    {
      title:'摄像头',
      icon: 'icon-camera',
      params: [
        ['视角', '水平 98°，垂直 52°'],
        ['图像传感器', '1/2.8"'],
        ['光圈', 'F1.8大'],
        ['摄像头', ['高清1080P', '星光级全彩']],
      ],
    },
    {
      title:'音箱',
      icon: 'icon-voicebox',
      params: [
        ['输出功率', '2X10W'],
        ['声道', '双声道，立体声'],
        ['频响范围', 'TBD'],
      ],
    },
    {
      title:'麦克风',
      icon: 'icon-mic',
      params: [
        ['阵列数', '6'],
        ['声源定位', '360°'],
        ['特色功能', '回声消除、稳态/动态噪声抑制、语音增强'],
      ],
    },
    {
      title:'屏幕尺寸',
      icon: 'icon-screen',
      params: [
        ['显示屏', '10.1"IPS'],
        ['分辨率', ['1080X720', '支持多点触摸']],
      ],
    },
    {
      title:'核心硬件',
      icon: 'icon-hardware',
      params: [
        ['CPU', '双CPU，六核64位高性能处理器'],
        ['RAM', '4GB'],
        ['ROM', '16GB'],
      ],
    },
    {
      title:'运动',
      icon: 'icon-move',
      params: [
        ['行走', '正常速度0.4m/s、最大速度可达0.8/s'],
        ['俯仰', '范围0~55°，速度45°/s'],
        ['水平旋转', '范围-150°~150°、速度45°/s'],
        ['上下伸缩', '区间7cm、速度3cm/s'],
      ],
    },
    {
      title:'传感器',
      icon: 'icon-sensor',
      params: [
        ['超声传感器', '4'],
        ['防跌落传感器', '4'],
        ['环境传感器', '1'],
        ['IMU', '1'],
        ['激光雷达', '1'],
        ['深度相机', '1'],
        ['光线距离传感器', '1'],
      ],
    },
    {
      title:'无线通讯',
      icon: 'icon-wifi',
      params: [
        ['Wi-Fi', '802.11b/g/n(2.4GHz)'],
      ],
    },
    {
      title:'电源',
      icon: 'icon-battery',
      params: [
        ['电池', '18650锂电池、容量10400mAh、额定电压11.1V'],
        ['充电方式', '自动回充'],
      ],
    },
  ],
}


// WEBPACK FOOTER //
// ./src/config/spec.js